export const getItemColor = (
	item: { chance: number; price: number },
	price: number
) =>
	item.chance < 1
		? 'orange'
		: item.chance < 2
			? 'red'
			: item.price > price
				? 'pink'
				: 'blue'
